import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { FaEnvelope } from 'react-icons/fa';
import { useAuthContext } from '../../../context/AuthContext';

const SmsDetailsModal = ({ show, handleClose, sms }) => {
  const { isAuthenticated } = useAuthContext();

  if (!sms) return null;

  if (!isAuthenticated) return null;

  return (
    <>
      <Modal show={show} onHide={handleClose} centered size="lg">
        <Modal.Header closeButton className="border-0">
          <Modal.Title>
            <FaEnvelope className="me-2" style={{ color: '#4169e1' }} /> 
            SMS Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Form.Label className="text-muted fw-bold" style={{ fontSize: '13px' }}>Recipient Name</Form.Label>
                  <Form.Control type="text" readOnly value={sms.recipientName || 'N/A'} className="bg-light" />
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Form.Label className="text-muted fw-bold" style={{ fontSize: '13px' }}>Phone Number</Form.Label>
                  <Form.Control type="text" readOnly value={sms.phoneNumber || 'N/A'} className="bg-light" />
                </Form.Group>
              </div>
            </div>

            <div className="row">
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Form.Label className="text-muted fw-bold" style={{ fontSize: '13px' }}>Status Response</Form.Label>
                  <Form.Control type="text" readOnly value={sms.status_response || sms.statusResponse || sms.status || 'N/A'} className="bg-light" />
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Form.Label className="text-muted fw-bold" style={{ fontSize: '13px' }}>Status Message</Form.Label>
                  <Form.Control type="text" readOnly value={sms.status_message || sms.statusMessage || 'N/A'} className="bg-light" />
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Form.Label className="text-muted fw-bold" style={{ fontSize: '13px' }}>Date & Time</Form.Label>
                  <Form.Control type="text" readOnly value={sms.muda || 'N/A'} className="bg-light" />
                </Form.Group>
              </div>
            </div>

            <Form.Group className="mb-3">
              <Form.Label className="text-muted fw-bold" style={{ fontSize: '13px' }}>Full Message</Form.Label>
              <Form.Control as="textarea" rows={4} readOnly value={sms.message || 'N/A'} className="bg-light" />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SmsDetailsModal;
